"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error for debugging
    console.error(error);
  }, [error]);

  return (
    <div className="flex-1 flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md mx-auto p-6">
        <h2 className="text-xl font-semibold text-[#090C0F] mb-2">
          Something went wrong
        </h2>
        <p className="text-[#454950] mb-6">
          An unexpected error occurred. Please try again.
        </p>
        <button
          onClick={reset}
          className="px-6 py-2.5 bg-[#003399] text-white rounded-[8px] hover:bg-[#013eb9] transition-colors font-medium"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
